import PropTypes from 'prop-types'
import { Element } from '../../../common/html/element'
import classes from './index.module.scss'

const ChaperHeader = ({ title }) => {
  return (
    <Element
      className={`fw600 ${classes.textEllipsisTwoLine}`}
      style={{
        color: '#234891',
        fontSize: 25,
      }}
    >
      {title.toUpperCase()}
    </Element>
  )
}

ChaperHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default ChaperHeader
